// extracted by mini-css-extract-plugin
export default {"root":"CenterText_root__hHSoI","movein":"CenterText_movein__xo5ne"};